import type { CMSGwpPromotion } from '@/types/sanity'
import { atom, computed } from 'nanostores'

export const $activeGwpPromotions = atom<CMSGwpPromotion[]>([])

export const $activeProductGwpPromotions = computed(
  $activeGwpPromotions,
  ($promotions) => {
    return $promotions.filter((promotion) => promotion.type === 'product')
  },
)

export const $activeAmountGwpPromotions = computed(
  $activeGwpPromotions,
  ($promotions) => {
    return $promotions.filter((promotion) => promotion.type === 'amount')
  },
)
